import { render, staticRenderFns } from "./CollapsableCard.vue?vue&type=template&id=a6be7fb6"
import script from "./CollapsableCard.vue?vue&type=script&lang=js"
export * from "./CollapsableCard.vue?vue&type=script&lang=js"
import style0 from "./CollapsableCard.vue?vue&type=style&index=0&id=a6be7fb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports